import { Login } from "../app/Login/screen/Login";
import { useNavigate } from "react-router-dom";
import { getUserLocalStorage } from "../context/util";
import { URLS } from "./URLS";

export const PrivateRouter = ({ children }: { children: JSX.Element }) => {
  const userLocalStorage = getUserLocalStorage();
  const navigate = useNavigate();

  if (!userLocalStorage?.accessToken) {
    navigate(URLS.LOGIN);
    return <Login />;
  }

  return children;
};
